import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { DocumentsListResponseModel } from '@gtpl/shared-models/logistics';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { Repository } from 'typeorm';
import { DocumentFileUploadResponse, SaleOrderRequest } from '../../../../../../libs/shared-models/logistics/src/lib/documents-list';
import { DocumentsList } from './documents-list.entity';
import { DocumentsListRequest } from './dto/document-list.request';
import { DocumentsListAdapter } from './dto/documents-list.adapters';
import { DocumentsListRepository } from './repository/documents-list.repository';

@Injectable()
export class DocumentsListService {
    constructor(
        @InjectRepository(DocumentsList)
        private documentsListRepository: DocumentsListRepository,
        private documentsListAdapter: DocumentsListAdapter,
      ) {}
    async getDocumentsList(saleOrderRequest: SaleOrderRequest): Promise<DocumentsListResponseModel> {
        try{
            const documentsData:DocumentsList[] = await this.documentsListRepository.find({where:{saleOrderId:saleOrderRequest.saleOrderId, documentCategory: saleOrderRequest.documentCategory}});
            if(documentsData.length>0){
                return new DocumentsListResponseModel(true,1001,'Documents List retrived successfully. ', documentsData);
            }
            else{
                return new DocumentsListResponseModel(false,1001,'No data found. ', documentsData);
            }
        }catch(error){
            return error;
        }
    }
    async getDocumentsDetailsBySoId(saleOrderRequest: SaleOrderRequest): Promise<DocumentsListResponseModel> {
        try{
            const documentsData:DocumentsList[] = await this.documentsListRepository.createQueryBuilder('documents_list')
            .where(`sale_order_id = `+saleOrderRequest.saleOrderId)
            // .andWhere(`document_type = '`+saleOrderRequest.documentType + `'`)
            .andWhere(`document_category NOT IN ("SIMP","CO","DS","OBL","Bill Of Lading","Shipping Instructions")`)
            .groupBy('document_category')
            .getMany();
            // const documentsData:DocumentsList[] = await this.documentsListRepository.find({where:{saleOrderId:saleOrderRequest.saleOrderId},});
            if(documentsData.length>0){
                return new DocumentsListResponseModel(true,1001,'Documents List retrived successfully. ', documentsData);
            }
            else{
                return new DocumentsListResponseModel(false,1001,'No data found. ', documentsData);
            }
        }catch(error){
            return error;
        }
    }
    async getDocumentsDetailsForSoId(saleOrderRequest: SaleOrderRequest): Promise<DocumentsListResponseModel> {
        try{
            const documentsData:DocumentsList[] = await this.documentsListRepository.createQueryBuilder('documents_list')
            .where(`sale_order_id = `+saleOrderRequest.saleOrderId)
            // .andWhere(`document_type = '`+saleOrderRequest.documentType + `'`)
            .andWhere(`document_category NOT IN ("SIMP","CO","DS","OBL","Bill Of Lading","Shipping Instructions")`)
            .getMany();
            // const documentsData:DocumentsList[] = await this.documentsListRepository.find({where:{saleOrderId:saleOrderRequest.saleOrderId},});
            if(documentsData.length>0){
                return new DocumentsListResponseModel(true,1001,'Documents List retrived successfully. ', documentsData);
            }
            else{
                return new DocumentsListResponseModel(false,1001,'No data found. ', documentsData);
            }
        }catch(error){
            return error;
        }
    }
    async createDocumentsList(documentsListRequest: DocumentsListRequest, isUpdate: boolean,): Promise<DocumentsListResponseModel> {
        console.log(documentsListRequest);
        
        const manager = new GenericTransactionManager();
        try{
            const data:DocumentsList[] = [];
            await manager.startTransaction();
            let flag:boolean =true;
            // for(const doc of documentsListRequest.file){

                const convertedDto = await this.documentsListAdapter.convertDtoToEntity(documentsListRequest);
                const savedDoc = await manager.getCustomRepository(DocumentsListRepository).save(convertedDto);
                // data.push(savedDoc);
                if(!savedDoc){
                    flag=false;
                }
            // }

            if(flag){
                await manager.completeTransaction();
                return new DocumentsListResponseModel(true, 1001, 'Document Uploaded Successfully. ', savedDoc);
            }else{
                throw new ErrorResponse(9999, 'Something Went Wrong')
            }
        }catch(error){
            await manager.releaseTransaction();
            return error;
        }
    }

    
  /**
   *
   * @param filePath
   * @param saleOrderId
   * @returns
   */
  async updatePath(
      file:any[],
    filePath: string,
    saleOrderId: number,
    documentCategory: string,
    documentsListId: number[],
  ): Promise<DocumentFileUploadResponse> {
      console.log(documentsListId);
      console.log(documentsListId.length);

      try{
          console.log('try');
          let status = false;
            await file.forEach(async (element,index) => {
                let id = documentsListId.length > 1 ?documentsListId[index]:documentsListId
              console.log(documentsListId[index]);
              console.log(index,element);
              const filePathUpdate = await this.documentsListRepository.update(
                { saleOrderId: saleOrderId, documentCategory:documentCategory, documentsListId:documentsListId[index] },
                { filePath: filePath+element.filename,fileName: element.originalname, isUploaded: true }
              );
              console.log(filePathUpdate)
                if (filePathUpdate.affected > 0) {
                    status = true;
                } 
          });
          console.log(status);
        if (status) {
            return new DocumentFileUploadResponse(true,1001,'uploaded successfully. ',"");
        }
        else{
            return new DocumentFileUploadResponse(false,1011,'Something went wrong. ',"");
        }
    }catch(error){
        console.log(error);
        return error;
    }
  }

}
